import React from 'react';

import { AlineTooltip, SelectButton } from 'src/components';
import { DeclarativeMenu } from 'src/components/declarative-menu';
import { LineSpacingIcon } from 'src/components/icons/LineSpacingIcon';
import { useEditorLoading } from 'src/layout-engine';
import { makeStyles } from 'tss-react/mui';

import { useLineSpacingMenu } from '../../shared/use-line-spacing-menu';

const useStyles = makeStyles()(theme => ({
  button: {
    marginLeft: theme.spacing(0.5),
  },
}));

export function LineSpacingMenu(): JSX.Element {
  const { classes } = useStyles();
  const editorLoading = useEditorLoading();
  const lineSpacingMenu = useLineSpacingMenu();

  return (
    <DeclarativeMenu config={lineSpacingMenu} disabled={editorLoading}>
      {(renderProps, state) => (
        <AlineTooltip arrow title="Line spacing">
          <SelectButton
            className={classes.button}
            disabled={state.disabled}
            selected={state.open}
            {...renderProps}
          >
            <LineSpacingIcon />
          </SelectButton>
        </AlineTooltip>
      )}
    </DeclarativeMenu>
  );
}
